<template>
  <div class="add-pay-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="680px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="130px">
        <div class="form-flex-box">
          <el-form-item label="货币名称:" prop="name">
            <el-input v-model="params.name" size="small"></el-input>
          </el-form-item>
          <el-form-item label="货币类型:" prop="type">
            <el-select
                v-model="params.type"
                size="small"
                placeholder="请选择货币类型"
                @change="checkGameGold()"
                clearable
            >
              <el-option
                  v-for="item in currencyType"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="购买货币数:" prop="coins">
            <el-input v-model.number="params.coins" size="small"></el-input>
          </el-form-item>
          <el-form-item label="价格(分):" prop="price">
            <el-input v-model.number="params.price" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="优惠描述:" prop="couponDesc">
            <el-input v-model="params.couponDesc" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if="params.type === 2 || params.type === 3" label="赠送果币:" prop="giveFruitCoin">
            <el-input v-model.number="params.giveFruitCoin" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="赠送金币:" prop="giveGold">
            <el-input v-model.number="params.giveGold" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赠送游戏金币:" prop="giveGameCoin">
            <el-input v-model.number="params.giveGameCoin" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item v-if="isGameGold" label="首次赠送vip天数:" prop="firstGiveVipDays">
            <el-input v-model.number="params.firstGiveVipDays" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if="isGameGold" label="首次赠送游戏金币:" prop="firstGiveGameCoin">
            <el-input v-model.number="params.firstGiveGameCoin" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item v-if="isGameGold" label="赠送vip天数:" prop="giveVipDays">
            <el-input v-model.number="params.giveVipDays" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if="isGameGold" label="楼凤解锁次数:" prop="louFengUnlockTimes">
            <el-input v-model.number="params.louFengUnlockTimes" size="small"></el-input>
          </el-form-item>
        </div>
        <!-- <el-form-item label="赠送果币:" prop="giveGameCoin">
          <el-input v-model.number="params.giveGameCoin" size="small"></el-input>
        </el-form-item>
        <el-form-item label="赠送金币:" prop="giveGold">
          <el-input v-model.number="params.giveGold" size="small"></el-input>
        </el-form-item> -->
        <div class="form-flex-box">
          <el-form-item v-if="isGameGold" label="非首充赠送:">
            <el-switch v-model="params.notFirst">
            </el-switch>
          </el-form-item>
          <el-form-item label="激活:">
            <el-switch v-model="params.isActive">
            </el-switch>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      isGameGold: false,
      id: '',
      params: {
        name: '',
        type: '',
        coins: '',
        price:'',
        couponDesc:'',
        giveVipDays:'',
        firstGiveVipDays:'',
        firstGiveGameCoin:'',
        louFengUnlockTimes:'',
        giveGameCoin:'',
        giveFruitCoin: '',
        giveGold: '',
        notFirst: false,
        isActive: false
      },
      currencyType: [
        {label: '金币', value: 1},
        {label: '游戏币', value: 2},
        {label: '果币', value: 3},
      ],
      rules: {
        // name: [
        //   { required: true, message: '请输入配置名', trigger: 'blur' },
        // ],
        type: [
          { required: true, message: '请选择货币类型', trigger: 'blur' },
        ],
        coins: [
          { required: true, message: '请输入金币', trigger: 'blur' },
          { type: 'number', message: '金币必须为数字' }
        ],
        // giveFruitCoin: [
        //   { required: true, message: '请输入赠送果币', trigger: 'blur' },
        //   { type: 'number', message: '赠送果币必须为数字' }
        // ],
        // giveGold: [
        //   { required: true, message: '请输入赠送金币', trigger: 'blur' },
        //   { type: 'number', message: '赠送金币必须为数字' }
        // ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { type: 'number', message: '价格必须为数字' }
        ]
      }
    }
  },
  methods: {
    // 提交修改
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.flag = true
          if (this.title === '新增货币配置') {
            this.addGameGold()
          } else {
            this.editGameGold()
          }
        } else {
          return false
        }
      })
    },
    // 修改金币配置
    editGameGold() {
      let params = Object.assign({},this.params, { id: this.id,price: this.params.price })
      API.updateCurrency(params,true).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '修改货币配置成功',
            type: 'success'
          })
          this.$emit('handlerGoldList')
        } else {
          this.$message.error('修改货币配置失败')
        }
        this.flag = false
        this.handleClose()
      }).catch(() => {
        this.flag = false
        this.handleClose()
      })
    },
    // 添加金币配置
    addGameGold() {
      let params = Object.assign({},this.params, { price: this.params.price })
      API.addCurrency(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增货币配置成功',
            type: 'success'
          })
          this.$emit('handlerGoldList')
        } else {
          this.$message.error('新增货币配置失败')
        }
        this.flag = false
        this.handleClose()
      }).catch(() => {
        this.flag = false
        this.handleClose()
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        name: '',
        coins: '',
        type: '',
        price: '',
        giveGold: '',
        couponDesc:'',
        giveVipDays:'',
        firstGiveVipDays: '',
        firstGiveGameCoin: '',
        louFengUnlockTimes:'',
        giveGameCoin:'',
        giveFruitCoin: '',
        isActive: false,
        notFirst: false,
      }
      this.$refs['form'].resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑货币配置'
        this.params.name = data.name
        this.params.coins = data.coins
        this.params.price = data.price
        this.params.couponDesc = data.couponDesc
        this.params.giveVipDays = data.giveVipDays
        this.params.firstGiveVipDays = data.firstGiveVipDays
        this.params.firstGiveGameCoin = data.firstGiveGameCoin
        this.params.louFengUnlockTimes = data.louFengUnlockTimes
        this.params.giveGameCoin = data.giveGameCoin
        this.params.giveFruitCoin = data.giveFruitCoin
        this.params.giveGold = data.giveGold
        this.params.notFirst = data.notFirst
        this.id = data.id
        this.params.type = data.type
        this.params.isActive = data.isActive
        // window.console.log(data.giveFruitCoin)
        if (data.type === 2) {
          this.isGameGold = true
        } else {
          this.isGameGold = false
        }
      } else {
        this.title = '新增货币配置'
      }
    },
    checkGameGold() {
      if (this.params.type === 2) {
        this.isGameGold = true
      } else {
        this.isGameGold = false
      }
    }
  }

}
</script>

<style lang="scss" >
.add-pay-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
